import global from './Globals';

export default {
  tableBodyBg: 'white',
  tableHeaderBg: global.primary,
  tableHeaderText: global.white,
};
